import { useState, useEffect } from 'react';
import { Card, SectionTitle, Btn, FileUpload, Loader } from './UI';
import ReferralBoard from './ReferralBoard';
import {
  loadRegistry, parseRegistryFile, importRegistry, saveRegistryRecord, deleteRegistryRecord, nameTokens,
} from '../lib/referral';

const empty = { id: null, full_name: '', phone: '', email: '', snils: '', bonus: '' };

function RegistryEditor() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  const [edit, setEdit] = useState(null);
  const [msg, setMsg] = useState('');
  const [file, setFile] = useState(null);
  const [parsed, setParsed] = useState(null);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  async function load() { try { setRows(await loadRegistry()); } catch (e) { setMsg('Ошибка: ' + (e.message || e)); setRows([]); } }
  useEffect(() => { load(); }, []);

  async function onFile(f) {
    setFile(f); setParsed(null); setRes(null); setMsg('');
    try { setParsed(await parseRegistryFile(f)); } catch (e) { setMsg(e.message || String(e)); }
  }
  async function apply() {
    setBusy(true); setMsg('');
    try { setRes(await importRegistry(parsed)); setFile(null); setParsed(null); await load(); }
    catch (e) { setMsg('Ошибка: ' + (e.message || e)); } finally { setBusy(false); }
  }
  async function save() {
    setMsg('');
    try { await saveRegistryRecord(edit); setEdit(null); await load(); } catch (e) { setMsg(e.message || String(e)); }
  }
  async function del(r) {
    if (!window.confirm('Удалить запись «' + r.full_name + '»?')) return;
    try { await deleteRegistryRecord(r.id); await load(); } catch (e) { setMsg(e.message || String(e)); }
  }

  if (!rows) return <Loader />;
  const ql = q.trim().toLowerCase();
  const qd = q.replace(/\D/g, '');
  const shown = rows.filter(r => !ql || nameTokens(r.full_name).join(' ').includes(nameTokens(ql).join(' ')) ||
    (qd.length >= 4 && ((r.phone || '').includes(qd) || (r.snils || '').includes(qd))) || (r.email || '').includes(ql)).slice(0, 100);
  const inp = { padding: '8px 10px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, width: '100%', boxSizing: 'border-box' };

  return (
    <div>
      <Card><div style={{ padding: 16 }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Загрузить выгрузку подключённых (раз в неделю)</div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>
          Берём фамилию и имя, телефон, почту и СНИЛС (если есть). Колонки «Проект» и даты игнорируются. Телефоны и порядок слов в ФИО приводятся к единому виду, дубли обновляются.
        </div>
        <FileUpload accept=".xlsx,.xls,.csv" onFile={onFile} hint=".xlsx или .csv" />
        {file && <div style={{ marginTop: 8, fontSize: 13 }}>📄 {file.name}{parsed && ` — найдено строк: ${parsed.length}`}</div>}
        {parsed && <Btn size="full" style={{ marginTop: 10 }} onClick={apply} disabled={busy || !parsed.length}>{busy ? 'Загружаю…' : 'Применить импорт'}</Btn>}
        {res && <div style={{ marginTop: 10, fontSize: 13, color: 'var(--green)' }}>✓ Новых: {res.added}, обновлено: {res.updated}, пропущено: {res.skipped}</div>}
        {msg && <div style={{ marginTop: 10, fontSize: 12, color: 'var(--red)' }}>{msg}</div>}
      </div></Card>
      <div style={{ height: 14 }} />
      <Card><div style={{ padding: 16 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
          <div style={{ fontWeight: 600, flex: 1 }}>Реестр · {rows.length} записей</div>
          <Btn size="sm" onClick={() => setEdit({ ...empty })}>+ Добавить</Btn>
        </div>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Поиск по имени, телефону, почте, СНИЛС" style={{ ...inp, marginBottom: 10 }} />
        {edit && (
          <div style={{ background: 'var(--surface2)', borderRadius: 10, padding: 12, marginBottom: 12, display: 'grid', gap: 8 }}>
            <input style={inp} placeholder="Фамилия и имя" value={edit.full_name} onChange={e => setEdit({ ...edit, full_name: e.target.value })} />
            <input style={inp} placeholder="Телефон" value={edit.phone || ''} onChange={e => setEdit({ ...edit, phone: e.target.value })} />
            <input style={inp} placeholder="Почта" value={edit.email || ''} onChange={e => setEdit({ ...edit, email: e.target.value })} />
            <input style={inp} placeholder="СНИЛС (если есть)" value={edit.snils || ''} onChange={e => setEdit({ ...edit, snils: e.target.value })} />
            <input style={inp} placeholder="Начислено бонусов" value={edit.bonus == null ? '' : edit.bonus} onChange={e => setEdit({ ...edit, bonus: e.target.value })} />
            <div style={{ display: 'flex', gap: 8 }}><Btn size="sm" onClick={save}>Сохранить</Btn><Btn size="sm" color="ghost" onClick={() => setEdit(null)}>Отмена</Btn></div>
          </div>)}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', minWidth: 560, borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ textAlign: 'left', color: 'var(--text-muted)', fontSize: 11 }}>
              <th style={{ padding: 6 }}>Фамилия и имя</th><th style={{ padding: 6 }}>Телефон</th><th style={{ padding: 6 }}>Почта</th><th style={{ padding: 6 }}>СНИЛС</th><th style={{ padding: 6 }}>Бонусы</th><th /></tr></thead>
            <tbody>{shown.map(r => (
              <tr key={r.id} style={{ borderTop: '1px solid #EEF1F7' }}>
                <td style={{ padding: 6, fontWeight: 500 }}>{r.full_name}</td>
                <td style={{ padding: 6 }}>{r.phone || '—'}</td>
                <td style={{ padding: 6 }}>{r.email || '—'}</td>
                <td style={{ padding: 6 }}>{r.snils || '—'}</td>
                <td style={{ padding: 6 }}>{r.bonus == null ? '—' : r.bonus}</td>
                <td style={{ padding: 6, whiteSpace: 'nowrap' }}>
                  <span style={{ color: 'var(--accent)', cursor: 'pointer', marginRight: 10 }} onClick={() => setEdit({ ...r })}>Править</span>
                  <span style={{ color: 'var(--red)', cursor: 'pointer' }} onClick={() => del(r)}>Удалить</span></td>
              </tr>))}
              {!shown.length && <tr><td colSpan={6} style={{ padding: 14, color: 'var(--text-muted)' }}>Ничего нет</td></tr>}
            </tbody>
          </table>
        </div>
        {rows.length > 100 && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>Показаны первые 100, остальные ищите поиском.</div>}
      </div></Card>
    </div>
  );
}

export default function ReferralAdmin() {
  const [sub, setSub] = useState(0);
  const tabBtn = (i, label) => (
    <button key={i} onClick={() => setSub(i)} style={{
      padding: '7px 14px', fontSize: 13, border: 'none', borderRadius: 8, cursor: 'pointer',
      background: sub === i ? 'var(--accent)' : 'var(--surface2)', color: sub === i ? 'white' : 'var(--text-muted)', fontWeight: 600,
    }}>{label}</button>);
  return (
    <div>
      <SectionTitle>Приведи друга</SectionTitle>
      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>{tabBtn(0, 'Результаты')}{tabBtn(1, 'Реестр подключённых')}</div>
      {sub === 0 ? <ReferralBoard mode="admin" /> : <RegistryEditor />}
    </div>
  );
}
